window.okeReviewsWidgetOnInit = function () {
  const writeAReviewButton = document.querySelector('.js-okeReviews-writeReview');
  const aggregateRating = document.querySelector('.okeReviews-reviewsAggregate-summary-rating');
  const reviewsControl = document.querySelector('.okeReviews-reviews-controls');

  if (writeAReviewButton) {
      writeAReviewButton.innerText = 'Leave a Review';
      // Insert WAR button into header
      if (writeAReviewButton && reviewsControl) {
          const reviewsControlSelect = reviewsControl.querySelector('.okeReviews-reviews-controls-select');
          reviewsControlSelect.insertAdjacentElement('afterbegin', writeAReviewButton);
      }
  }

  // Insert Aggregate Rating into header
  const reviewsCount = document.querySelector('.okeReviews-reviews-controls-reviewCount');
  if (aggregateRating && reviewsCount) {
      aggregateRating.insertAdjacentElement('beforeend', reviewsCount);
      reviewsControl.insertAdjacentElement('afterbegin', aggregateRating);
  }
}